import React from "react";

export const SectionHeading = ({ overline, title, subtitle, center = true, as: Tag = "h2" }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-12`}>
    {overline && (
      <div className="inline-block text-xs uppercase tracking-[0.2em] font-bold text-terracotta-600 mb-3">
        {overline}
      </div>
    )}
    <Tag className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-forest-800">
      {title}
    </Tag>
    {subtitle && <p className="mt-4 text-base text-soil-500">{subtitle}</p>}
  </div>
);
